import { Container } from "react-bootstrap";
import { Logo } from "../../../../general/modules/commons/logo/logo";

export const AuthHeader = () => {
  return (
    <div className="auth-header">
      <Container>
        <Logo height={50} width={100} />
      </Container>
    </div>
  );
};
